import { Grid, Tooltip, IconButton, Dialog, Paper, Theme, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import { ComponentClass } from "react";
import { ReactNode } from "react";
import { ISubmitEvent } from "react-jsonschema-form";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import { BranchActions, BranchStore } from "src/store/branch";
import { JSONSchema6 } from "json-schema";
import AddIcon from '@material-ui/icons/Add';
import GetApp from '@material-ui/icons/GetApp';
import { mockTheme, toMap } from "src/utils/utils";
import { AppDispatch, IStore } from "src/store";
import { connect } from "react-redux";
import { Company } from "src/api/model";
import { CompanyActions, CompanyState } from "src/store/company";
import { bindActionCreators } from "redux";
import { Delete, Edit } from "@material-ui/icons";
import { BranchData } from "src/components/BranchSelector";
import { Dot } from "src/components/enhancedMap";
import BranchForm from "src/components/branchForm";
import { ConfigData } from "src/config";


const styles = (theme: Theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    routeSelector: {
        width: "100%",
        height: "100%"
    },
    buttons: {
        marginLeft: "auto",
    },
    abm: {
        padding: theme.spacing.unit * 3,
        margin: theme.spacing.unit,
    }
});

const classesType = styles(mockTheme);

interface BranchProps extends WithStyles<keyof typeof classesType> {
    actions: BranchActions;
    companyActions: CompanyActions;
    branchActions: BranchActions;
    data: BranchStore;
    config: ConfigData;
    companies: CompanyState;
}

interface BranchState {
    table: {
        data: any[],
        sortBy: string,
        sortDirection: string
    },
    abm: {
        open: boolean
        companies: Company[],
        schema: JSONSchema6,
        select?: { branch: BranchData, location: Dot },
        openEdit: boolean,
    }
}

class Branch extends React.Component<BranchProps, BranchState> {

    columnData = [
        { path: "name", numeric: false, disablePadding: true, label: "Nombre" },
        { path: "company.name", numeric: false, disablePadding: false, label: "Compania" },
        { path: "location.street1", numeric: false, disablePadding: false, label: "Calle principal" },
        { path: "location.street2", numeric: false, disablePadding: false, label: "Calle secundaria" },
        { path: "location.number", numeric: true, disablePadding: false, label: "Numero" },
        {
            path: '', numeric: true, label: "", draw: (cd: ColumnDefinition, data: BranchData) => {
                return (
                    <IconButton aria-label='Editar' title='Editar'
                        onClick={this.edit(data)}>
                        <Edit />
                    </IconButton>
                );
            }
        },
        {
            path: '', numeric: true, label: "", draw: (cd: ColumnDefinition, data: BranchData) => {
                return (
                    <IconButton aria-label='Eliminar' title='Eliminar'
                        onClick={this.delete(data.id ? data.id : 0)}>
                        <Delete />
                    </IconButton>
                );
            }
        },
    ];

    private schema: JSONSchema6 = {
        definitions: {
            company: {
                type: 'object',
                required: ['name'],
                properties: {
                    name: {
                        type: 'string',
                        title: 'Nombre de la empresa',
                        "anyOf": [
                            { "type": "string", "enum": ['1'], "title": "Empresa" },
                            { "type": "string", "enum": ['2'], "title": "Empresa2" },
                            { "type": "string", "enum": ['106456'], "title": "Empresa_default" }
                        ],
                        // default: ['106456']
                    },
                }
            },
            location: {
                type: 'object',
                required: ['street1'],
                properties: {
                    street1: { type: "string", title: "Calle principal" },
                    street2: { type: "string", title: "Calle secundaria" },
                    number: { type: "string", title: 'Numero' },
                    lat: { type: "number", title: "Latitud" },
                }
            },
            branch: {
                type: 'object',
                required: ['name'],
                properties: {
                    name: { type: "string", title: "Nombre" },
                    referenceId: { type: "string", title: "Id de Referencia Ping" },
                    price: { type: "number", title: "Precio por delivery", minimum: 0 },
                    maxDistanceValidation: { type: "boolean", title: "Habilitar distancia máxima del conductor con referencia al punto de entrega?", default: false },
                    // limit: {type: "number", title: "Distancia máxima (distancia en metros máxima que el conductor puede estar situado de su destino para finalizar la entrega)", minimum: 0},
                    inicioVentana: { type: "string", title: "Inicio ventana de entrega (HH:mm)", pattern: "^(?:[01]\\d|2[0-3]):[0-5]\\d$" },
                    finVentana: { type: "string", title: "Fin ventana de entrega (HH:mm)", pattern: "^(?:[01]\\d|2[0-3]):[0-5]\\d$" },
                },
                dependencies: {
                    maxDistanceValidation: {
                        oneOf: [
                            {
                                properties: {
                                    maxDistanceValidation: { enum: [false] }
                                }
                            },
                            {
                                properties: {
                                    maxDistanceValidation: { enum: [true] },
                                    maxDistance: {
                                        type: "number",
                                        title: "Distancia máxima (distancia en metros máxima que el conductor puede estar situado de su destino para finalizar la entrega)",
                                        minimum: 0
                                    }
                                },
                                // required: ["limit"]
                            }
                        ]
                    }
                }
            }
        },
        title: "Sucursal",
        type: "object",
        required: ["company", "location", "branch"],
        properties: {
            branch: { title: "Detalles", $ref: "#/definitions/branch" },
            company: {
                title: "Empresa",
                anyOf: [
                    { "type": "string", "enum": ['1'], "title": "Empresa" },
                    { "type": "string", "enum": ['2'], "title": "Empresa2" },
                    { "type": "string", "enum": ['106456'], "title": "Empresa_default" }
                ],
                type: "string",
            },
            // company: {title: 'Empresa', "$ref": "#/definitions/company"},
            observation: { type: "string", title: "Observaciones" },
            location: { title: 'Ubicacion', "$ref": "#/definitions/location" },
        }
    };

    constructor(props: BranchProps) {
        super(props);
        this.state = {
            table: {
                data: [],
                sortBy: "name",
                sortDirection: "desc"
            },
            abm: {
                companies: [],
                schema: this.schema,
                open: false,
                openEdit: false
            }
        };
        this.hideDialog = this.hideDialog.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.showDialog = this.showDialog.bind(this);
        this.updateCompanyList = this.updateCompanyList.bind(this);
        this.exportCSV = this.exportCSV.bind(this);
    }

    edit(data: BranchData) {
        console.log(data);
        return (event: React.MouseEvent<HTMLElement>) => {
            this.props.companyActions.fetch();
            const newData = {
                ...data,
                branch: { 
                    name: data.name,
                    referenceId: data.referenceId || "",
                    maxDistanceValidation: data.maxDistanceValidation || false,
                    maxDistance: data.maxDistance || 0,
                    inicioVentana: data.inicioVentana || "",
                    finVentana: data.finVentana || "",
                },
                location: {
                    ...data.location,
                    street2: data.location.street2 || "",
                    number: data.location.number || ""
                },
                
            }
            this.setState({
                abm: {
                    ...this.state.abm,
                    select: {
                        branch: newData,
                        location: new Dot(data.location.lat, data.location.lng),
                    },
                    openEdit: true
                }
            });
        }
    }
    delete(id: number) {
        return async (event: React.MouseEvent<HTMLElement>) => {
            if(!id || id === 0){
                return;
            }
            await this.props.branchActions.delete(id);
        }
    }

    handleSubmitEdit(e: ISubmitEvent<any>) {
        const dato = {
            name: e.formData.name,
            referenceId: e.formData.referenceId || "",
            lat: e.formData.location.lat,
            lng: e.formData.location.lng,
            street1: e.formData.location.street1,
            street2: e.formData.location.street2,
            number: e.formData.location.number,
            observation: e.formData.observation,
            companyId: e.formData.company.id,
            maxDistanceValidation: e.formData.maxDistanceValidation,
            maxDistance: e.formData.maxDistance,
            inicioVentana: e.formData.inicioVentana,
            finVentana: e.formData.finVentana,
        }
        console.log(dato);
        this.props.actions.update(e.formData.id, dato);
        this.props.actions.fetch();
        this.hideDialog();
    }

    handleSubmit(e: ISubmitEvent<any>) {
        console.log(e.formData);
        const dato = {
            name: e.formData.name,
            referenceId: e.formData.referenceId || "",
            lat: e.formData.location.lat,
            lng: e.formData.location.lng,
            street1: e.formData.location.street1,
            street2: e.formData.location.street2,
            // number: e.formData.location.number,
            observation: e.formData.observation || "",
            companyId: e.formData.company.id,
            maxDistanceValidation: e.formData.maxDistanceValidation,
            maxDistance: e.formData.maxDistance,
            inicioVentana: e.formData.inicioVentana,
            finVentana: e.formData.finVentana
        }
        this.props.actions.add(dato);
        this.hideDialog();
    }

    updateCompanyList() {
        const companyOptions = this.props.companies.data.data.map(company => ({
            type: "string",
            enum: [company.id.toString()],
            title: company.name
        }));
        const newSchema = JSON.parse(JSON.stringify(this.state.abm.schema));
        newSchema.properties.company = {
            ...newSchema.properties.company,
            anyOf: companyOptions,
        };
        this.setState({
            abm: {
                ...this.state.abm,
                schema: newSchema,
            }
        }
        );
    }

    componentDidUpdate(prevProps: Readonly<BranchProps>, prevState: Readonly<BranchState>, snapshot?: any): void {
        if (prevProps !== this.props && this.props.companies.data.data.length > 0) {
            this.updateCompanyList();
        }
    }

    showDialog() {
        this.props.companyActions.fetch();
        this.setState({
            abm: {
                ...this.state.abm,
                open: true
            }
        });
    }

    hideDialog() {
        this.setState({
            abm: {
                ...this.state.abm,
                open: false,
                openEdit: false
            }
        });
    }

    componentDidMount(): void {
        this.props.actions.fetch();
    }

    exportCSV = () => {
        const branches = this.props.data.data.data;
        const centralBranch = branches.find((b: any) => b.name === "CENTRAL ACCESO SUR ÑEMBY");
        const central = centralBranch ? {
            name: centralBranch.name,
            lng: centralBranch.location.lng,
            lat: centralBranch.location.lat,
            ventana: "00:00:00, 23:59:59",
            demanda: 0,
            id: centralBranch.id
        } : {
            name: "CENTRAL ACCESO SUR ÑEMBY",
            lng: -57.5533906,
            lat: -25.3796875,
            ventana: "00:00:00, 23:59:59",
            demanda: 0,
            id: 0
        };
        const otherBranches = branches.filter((b: any) => b.name !== "CENTRAL ACCESO SUR ÑEMBY");
        const rows = [central, ...otherBranches.map((b: any) => ({
            name: b.name,
            lng: b.location.lng,
            lat: b.location.lat,
            ventana: `${b.inicioVentana ? b.inicioVentana : '06:00'}:00, ${b.finVentana ? b.finVentana : '22:00'}:00`,
            demanda: 0,
            id: b.id
        }))];
        const csvRows = rows.map(r => `"${r.name}","${r.lng}","${r.lat}","${r.ventana}","${r.demanda}","${r.id}"`);
        const header = '"suc_nom","suc_lon","suc_lat","ventana_tiempo","demanda","id"';
        const fullCsv = [header, ...csvRows].join('\n');
        const blob = new Blob([fullCsv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sucursales.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    render(): ReactNode {
        return (<Grid container spacing={24}>
            <Grid item sm={12}>
                <AsyncTable
                    columnDefinition={this.columnData}
                    showFiltro={true}
                    title="Sucursales"
                    data={this.props.data.data.data}
                    defaultOrder={{
                        name: "name",
                        direction: "desc"
                    }}
                    headerButtons={
                        <>
                            <Tooltip title="Agregar">
                                <IconButton aria-label="Agregar" onClick={this.showDialog}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Exportar CSV">
                                <IconButton aria-label="Exportar" onClick={this.exportCSV}>
                                    <GetApp />
                                </IconButton>
                            </Tooltip>
                        </>
                    } />

            </Grid>
            <Dialog open={this.state.abm.open}
                maxWidth="md"
                fullWidth={true}
            >
                <Paper className={this.props.classes.abm}>
                    <BranchForm
                        schema={this.state.abm.schema}
                        sendData={this.handleSubmit}
                        cancel={this.hideDialog}
                        config={this.props.config}
                    />
                </Paper>
            </Dialog>
            <Dialog open={this.state.abm.openEdit} maxWidth="md" fullWidth={true}>
                <Paper className={this.props.classes.abm}>
                    <BranchForm
                        schema={this.state.abm.schema}
                        sendData={this.handleSubmitEdit}
                        cancel={this.hideDialog}
                        config={this.props.config}
                        data={this.state.abm.select ? {
                            ...this.state.abm.select!.branch,
                            company: this.state.abm.select!.branch ? this.state.abm.select!.branch.company.id.toString() : undefined
                        }
                            : undefined}
                    />
                </Paper>
            </Dialog>
        </Grid>);
    }
}

const mapStateToProps = (state: IStore, ownProps: BranchProps) => ({
    ...ownProps,
    data: state.branch,
    companies: state.company,
    config: state.config.data,
});


const styled = withStyles(styles as any)(Branch);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
    return {
        actions: bindActionCreators(toMap(BranchActions), dispatch),
        companyActions: bindActionCreators(toMap(CompanyActions), dispatch),
        branchActions: bindActionCreators(toMap(BranchActions), dispatch),
    }
})(styled);

export default connected as ComponentClass<Partial<BranchProps>>;


// WEBPACK FOOTER //
// ./src/pages/branch.tsx